export default __webpack_public_path__ + "static/media/taylor.545e53ce.svg";